module.exports = __webpack_public_path__ + "static/media/iphone XR banner1.7fe75447.jpg";